import { useState, useEffect,useCallback } from 'react'
import { SidebarLayoutNew } from "../components/sidebar-layout-new"; 
import { Heading } from '../components/heading' 
import {  ArrowPathIcon  } from "@heroicons/react/20/solid";
import { Footer } from "../components/footer";
import { BreadcrumbsNew } from "../components/breadcrumbs";
import { Fragment } from "react/jsx-runtime";
import config from '../config.js'
import { PageInfo } from '../components/page-info';
import { Loader } from '../components/loader';
import {    Fieldset,Field,ErrorMessage, Label } from '../components/fieldset'
import { Button } from '../components/button'
import { useAlert } from "../components/customAlert";
import { useNavigate } from 'react-router-dom'; 
import { useSession } from '../components/session-provider'; 
const breadcrumbs_link = [{ name: "Adwords Sync", href: "#", current: true }];
export default function AdwordsConnect() {
 
  const [error, setError] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState("");
  const [loading, setLoading]           = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const { session } = useSession();

  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const varCmpId = session.sumo_account_id; 
/*
  useEffect(() => {
    async function loadData() {
      setLoading(true);
      try {
        const res = await fetch(`${config.apiPath}google-ads-php/api-process/get_subaccounts.php?cmpid=`+varCmpId);
        const data = await res.json();

        /-*if (data.status === "ok" && Array.isArray(data.rows)) { 
          const cleanRows = data.rows.filter(r => Array.isArray(r));
          setAccounts(cleanRows);
        }*-/
        console.log("API response:", data);

        if (data.status === "ok" && Array.isArray(data.rows)) {
            setAccounts(data.rows); // skip filtering initially
        }
      } catch (error) {
        showAlert("Failed to fetch adwords data", "" , "error", 3000);
      } finally {
        setIsDataLoaded(true);
        setLoading(false);
      }
    }

    loadData();
  }, []);
  */
useEffect(() => {
  async function loadData() {
    setLoading(true);
    try {
      const type = new URLSearchParams(window.location.search).get("type");
      const url = `${config.apiPath}google-ads-php/api-process/customerList.php?cmpid=${varCmpId}&type=${type}`;
      const res = await fetch(url);
      const data = await res.json();

      console.log("API response:", data);

      if (data.status === "ok" && Array.isArray(data.customer_ids)) {
        setAccounts(data.customer_ids); // set array of strings
      }
    } catch (error) {
      console.error(error);
      showAlert("Failed to fetch adwords data", "", "error", 3000);
    } finally {
      setIsDataLoaded(true);
      setLoading(false);
    }
  }

  loadData();
}, [varCmpId]);


  const handleMccSubmit = async () => {
  setLoading(true);
  setError("");
  setFormErrors({});

  // Validation
  if (!selected?.trim()) {
    setFormErrors({ adwords_id: "Choose your account" });
    setLoading(false);
    return;
  }

  try {
    const res = await fetch(`${config.apiPath}adwords_sync/save_adswords_data.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adwords_id: selected }),
    });

    const result = await res.json();

    if (result.status === "success") {
      showAlert(result.msg, "Status Update", "success", 3000);
      navigate("/title-test");
    } else {
      showAlert(result.msg || "Failed to update data", "", "error", 3000);
    }
  } catch (err) {
    console.log(err);
    showAlert("Network error occurred.", "", "error", 3000);
  } finally {
    setIsDataLoaded(true);
    setLoading(false);
  }
};
 
useEffect(() => {
  const handleMessage = (event) => {
    if (event.data?.event === "ads_connected") {
 
      showAlert(event.data.message, "Status Update", "success", 3000);
    }
  };

  window.addEventListener("message", handleMessage);

  return () => window.removeEventListener("message", handleMessage);
}, []);
 

   
    const page_info = `We connect securely to your Google Ads account to access campaign and ad group performance data.
This includes impressions, clicks, conversions, and cost metrics for better insight.
Your data is used only to provide reports and optimization suggestions.
Access is granted via Google’s secure OAuth2 system, and you can revoke it anytime.
We do not make changes to your ads or access billing information.`;
    return (
      <Fragment>
        <SidebarLayoutNew selected_menu="title-test">
          <BreadcrumbsNew pages={breadcrumbs_link} />
          <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
           
            <ArrowPathIcon  className="!size-8" />
            <Heading className="w-full">Adwords Sync</Heading>
          </div>
          <PageInfo info={page_info} />
 
   {isDataLoaded ? (
        <div className="w-full max-w-md">
        
      <form method="POST">
  <Fieldset>
    <div className="space-y-4">

      {/* ACCOUNT DROPDOWN */}
      <div className="flex flex-col">
        <label
          htmlFor="account"
          className="mb-1 text-sm font-medium text-gray-700"
        >
          Select Account
        </label>

            <select
  id="account"
  className="border border-gray-300 rounded-md p-2 w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
  value={selected}
  onChange={(e) => setSelected(e.target.value)}
>
  <option value="">Choose an account...</option>

  {accounts.map((account) => (
    <option key={account.id} value={account.id}>
      {account.name} - {account.id} 
    </option>
  ))}
</select>


        {formErrors.adwords_id && (
          <p className="text-sm text-red-600 mt-1">
            {formErrors.adwords_id}
          </p>
        )}
      </div>

      {/* MCC BUTTON */}
      <div className="flex justify-center">
        <Button
          type="button"
          onClick={handleMccSubmit}
          className="px-5 py-2 rounded-md"
        >
          Sync Now
        </Button>
      </div>

       

    </div>
  </Fieldset>
</form>


      </div> 

    ) : <Loader />   } {loading && (  <Loader /> )}    
        </SidebarLayoutNew>
        <Footer />
      </Fragment>
    );

   
} 